import * as colors from '@giphy/colors'
import styled from 'styled-components'

const Container = styled.div`
    box-sizing: content-box;
    display: inline-block;
    padding: 30px 20px;
    text-align: center;
    vertical-align: top;
    width: 190px;
`

const Icon = styled.div`
    background-color: ${colors.giphyBlack};
    background-position: center center;
    background-size: cover;
    border-radius: 8px;
    height: 70px;
    margin: 0 auto 15px;
    width: 70px;
`

const Title = styled.h4`
    font-weight: bold;
    margin-bottom: 8px;
`

const Subtitle = styled.div`
    margin-bottom: 15px;
`

const MoreButton = styled.a`
    background: ${colors.primaryCTA};
    color: ${colors.giphyWhite};
    display: inline-block;
    font-weight: bold;
    height: 36px;
    line-height: 36px;
    padding: 0 15px;
    text-align: center;

    &:hover {
        color: ${colors.giphyWhite};
    }
`

const AppButton = ({ icon_url: iconUrl, subheading, name, slug }) => (
    <Container>
        <Icon style={{ backgroundImage: `url(${iconUrl})` }} />
        <Title>{name}</Title>
        <Subtitle>{subheading}</Subtitle>
        <MoreButton href={`/apps/${slug}`}>Learn More</MoreButton>
    </Container>
)

export default AppButton
